import { WaveDivider } from './WaveDivider';

export default {
  title: 'Client/WaveDivider',
  component: WaveDivider,
  parameters: {
    layout: 'fullscreen',
  },
};

export const Wavy = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#f3f3f3',
      wave_opacity: 1,
      wave_style: 'wavy',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom',
      render_type: 'all',
      custom_id: '',
      custom_class: '',
      show_section_borders: false,
      padding_top_desktop: 0,
      padding_bottom_desktop: 0,
      padding_left_right_desktop: 0,
      padding_top_mobile: 0,
      padding_bottom_mobile: 0, 
      padding_left_right_mobile: 0
    }
  },
};

export const Jagged = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#f0e6e0',
      wave_opacity: 1,
      wave_style: 'jagged',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom',
      render_type: 'all',
      custom_id: '',
      custom_class: '',
      show_section_borders: false
    }
  },
};

export const Curved = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#e6f0f0',
      wave_opacity: 1,
      wave_style: 'curved',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom',
      render_type: 'all'
    }
  },
};

export const SingleCurve = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#ffffff',
      wave_opacity: 1,
      wave_style: 'single-curve',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom',
      background_color: '#333333'
    }
  },
};

export const Straight = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#e6e6f0',
      wave_opacity: 1,
      wave_style: 'straight',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom'
    }
  },
};

export const FlippedVertically = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#f3f3f3',
      wave_opacity: 1,
      wave_style: 'wavy',
      flip_vertically: true,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom'
    }
  },
};

export const BothPositions = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#f3f3f3',
      wave_opacity: 1,
      wave_style: 'wavy',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'both'
    }
  },
};

export const WithPadding = {
  args: {
    settings: {
      wave_height: 80,
      wave_color: '#f3f3f3',
      wave_opacity: 1,
      wave_style: 'wavy',
      flip_vertically: false,
      flip_horizontally: false,
      hide_on_mobile: false,
      z_index: 1,
      position: 'bottom',
      render_type: 'all',
      custom_id: 'wave-section',
      custom_class: 'custom-wave',
      show_section_borders: true,
      padding_top_desktop: 30,
      padding_bottom_desktop: 30,
      padding_left_right_desktop: 20,
      padding_top_mobile: 15,
      padding_bottom_mobile: 15,
      padding_left_right_mobile: 10
    }
  },
};